import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const navigate = useNavigate();
    
    // Redirect to EssenceEcho page immediately
    useEffect(() => {
        navigate('/essence-echo');
    }, [navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen">
                                                        <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                <p className="text-gray-600">Redirecting to Essence Echo...</p>
            </div>
        </div>
    );
};

export default Dashboard;
